import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { LottieAnimation } from '@dtx-company/shared-components/src/components/molecules/LottieAnimation'
import EmptyShoppingCartAnimationJson from './EmpytShoppingCartAnimation.lottie.json'
import React from 'react'

export const EmptyShoppingCartAnimation: React.FC = () => {
  return (
    <Box>
      <LottieAnimation
        animation={EmptyShoppingCartAnimationJson}
        loop
        autoplay
        aria-label="empty-shopping-cart-animation"
      />
    </Box>
  )
}
